import React, { useState } from "react";
import { CloudUploadIcon, XIcon } from "lucide-react";
import server from "../../utils/serverConfig";

const FileUploadEquity = () => {
  const [files, setFiles] = useState([]);
  const [uploadProgress, setUploadProgress] = useState({});
  const [csvData, setCsvData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const EQUITY_ENDPOINT = `${server.godseye.baseUrl}upload-pdf-equity`;

  const handleFileChange = (event) => {
    const selectedFiles = Array.from(event.target.files);
    const newFiles = selectedFiles.map((file) => ({ file, progress: 0 }));
    setFiles((prevFiles) => [...prevFiles, ...newFiles]);

    newFiles.forEach((fileWrapper) => {
      // Simulate file upload progress
      const interval = setInterval(() => {
        setUploadProgress((prevProgress) => {
          const newProgress = prevProgress[fileWrapper.file.name] + 20 || 20;
          if (newProgress >= 100) {
            clearInterval(interval);
          }
          return { ...prevProgress, [fileWrapper.file.name]: newProgress };
        });
      }, 500);
    });
    // Reset the input value to allow re-upload of the same file
    event.target.value = null;
  };

  const handleRemoveFile = (fileName) => {
    setFiles((prevFiles) =>
      prevFiles.filter((fileWrapper) => fileWrapper.file.name !== fileName)
    );
    setUploadProgress((prevProgress) => {
      const newProgress = { ...prevProgress };
      delete newProgress[fileName];
      return newProgress;
    });
  };

  const handleSend = async () => {
    setIsLoading(true);
    const formData = new FormData();
    files.forEach((fileWrapper) => formData.append("files", fileWrapper.file));

    try {
      const response = await fetch(EQUITY_ENDPOINT, {
        method: "POST",
        body: formData,
      });

      if (response.ok) {
        const blob = await response.blob();
        setCsvData(blob);
        console.log("Uploaded files:", files);
        setFiles([]);
        setUploadProgress({});
        setIsLoading(false);
      } else {
        console.error("Error uploading files");
        setIsLoading(false);
      }
    } catch (error) {
      console.error("Error uploading files:", error);
      setIsLoading(false);
    }
  };

  const handleDownload = () => {
    const url = URL.createObjectURL(csvData);
    const a = document.createElement("a");
    a.href = url;
    a.download = "equity-data.csv";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  const handleRefresh = () => {
    setFiles([]);
    setUploadProgress({});
    setCsvData(null);
  };

  return (
    <div className="flex flex-col mx-auto  lg:mt-20 w-[650px] px-8 py-6 rounded-md">
      <div className="flex items-center justify-between">
        <div className="text-2xl  text-center py-6 font-medium text-white ">
          File Upload Equity
        </div>
        <button
          onClick={handleRefresh}
          className=" mt-2 bg-red-500 text-white py-2 px-4 rounded hover:bg-red-600"
        >
          Refresh
        </button>
      </div>

      <div className=" h-[190px] flex flex-col justify-center px-6 py-6 border-2 border-dashed border-gray-700 rounded-lg text-center">
        <label className="cursor-pointer flex flex-col items-center">
          <div>
            <CloudUploadIcon className="w-16 h-16 text-gray-400 mb-2" />
          </div>
          <span className="text-gray-100">Click to upload</span>
          <input
            type="file"
            multiple
            accept=".pdf,.docx"
            className="hidden"
            onChange={handleFileChange}
          />
        </label>
      </div>
      <div className="flex flex-col space-y-4">
        <div className="mt-4">
          {files.map((fileWrapper, index) => (
            <div
              key={index}
              className="relative my-2 bg-white/10  px-5 py-3 rounded-md"
            >
              <div className="flex  justify-between items-center">
                <span className="text-gray-100 text-sm">
                  {fileWrapper.file.name}
                </span>
              </div>
              <div className="relative mt-2 w-full flex items-center rounded pr-16">
                <div
                  className="h-2 bg-blue-500 rounded"
                  style={{
                    width: `${uploadProgress[fileWrapper.file.name] || 0}%`,
                  }}
                ></div>
                <div className="absolute right-0 text-gray-100 text-xs font-medium">
                  {uploadProgress[fileWrapper.file.name] || 0}%
                </div>
              </div>
              <button
                className="absolute  top-2 right-4"
                onClick={() => handleRemoveFile(fileWrapper.file.name)}
              >
                <XIcon className="w-4 h-4 text-white/80" />
              </button>
            </div>
          ))}
        </div>

        <div className="flex">
          <button
            onClick={handleSend}
            className="w-full mt-2 bg-[#07F2C7]/80 text-white py-2 px-4 rounded hover:bg-[#07F2C7]  disabled:cursor-not-allowed"
            disabled={files.length === 0}
          >
            {isLoading ? "Generating CSV..." : "Generate Combined CSV"}
          </button>
        </div>
        {csvData && (
          <button
            onClick={handleDownload}
            className="mt-2 bg-blue-500 text-white py-2 px-4 rounded hover:bg-blue-600"
          >
            Download CSV
          </button>
        )}
      </div>
    </div>
  );
};

export default FileUploadEquity;
